'use client'

import { useFavoritesStore } from '@/lib/store/favorites-store'
import { useWallet } from '@/providers/WalletContext'
import { useModalStore } from '@/stores/modal-store'
import type { EventListItem } from '@/types/market'
import { useEffect } from 'react'

type FavoriteInput = Pick<EventListItem, 'id' | 'platform'>

export function useFavorites() {
	const favorites = useFavoritesStore(s => s.favorites)
	const isLoaded = useFavoritesStore(s => s.isLoaded)
	const loadFavorites = useFavoritesStore(s => s.loadFavorites)
	const toggleFavoriteStore = useFavoritesStore(s => s.toggleFavorite)
	const removeFavoriteStore = useFavoritesStore(s => s.removeFavorite)
	const isFavorite = useFavoritesStore(s => s.isFavorite)

	const { eoaAddress, authenticated } = useWallet()
	const openModal = useModalStore(s => s.openModal)

	// Load favorites when wallet address changes
	useEffect(() => {
		loadFavorites(eoaAddress)
	}, [eoaAddress, loadFavorites])

	// Wrapped toggle that checks authentication first
	const toggleFavorite = (event: FavoriteInput) => {
		if (!authenticated) {
			openModal('auth')
			return
		}
		toggleFavoriteStore(event, eoaAddress)
	}

	// Wrapped remove that passes wallet address
	const removeFavorite = (id: string, platform: EventListItem['platform']) => {
		removeFavoriteStore(id, platform, eoaAddress)
	}

	return {
		favorites,
		isLoaded,
		toggleFavorite,
		removeFavorite,
		isFavorite,
	}
}
